import { MerchantConfig } from '@/models/config/merchantConfig';
import MerchantConfigState from './merchantConfigState';

const state: MerchantConfigState = {
  merchantConfig: new MerchantConfig(),
};

export default state;
